import { type Tool } from '@ag-ui/core';

import { SUBSCRIBED_TOOLS } from './consts';
import { DETECT_TEXT_TOOL } from './detectText';
import { FILE_EDIT_COMPLETE_TOOL } from './fileEditComplete';
import { GENERATE_TEXT_TOOL } from './generateText';

/** All registered tools, passed to runAgent on every invocation. */
export const ALL_TOOLS: Tool[] = [FILE_EDIT_COMPLETE_TOOL, GENERATE_TEXT_TOOL, DETECT_TEXT_TOOL, ...SUBSCRIBED_TOOLS];

export { BaseToolResultSchema } from './baseResult';
// Re-export tool types
export {
  BRAND_KIT_SETUP_TOOL_NAME,
  type BrandKitSetupAction,
  type BrandKitSetupResult,
} from './brandKitSetup';
export {
  DETECT_TEXT_TOOL_NAME,
  type DetectTextRegion,
  type DetectTextResult,
} from './detectText';
export {
  ELICIT_MISSING_CONTEXT_TOOL_NAME,
  type ElicitMissingContextAction,
  type ElicitMissingContextCandidate,
  type ElicitMissingContextResult,
} from './elicitMissingContext';
export {
  FILE_EDIT_COMPLETE_TOOL_NAME,
  type FileEditCompleteArgs,
  type FileEditCompleteEdit,
  type FileEditCompleteImageEdit,
  type FileEditCompleteResult,
  type FileEditCompleteTextEdit,
  isImageEdit,
} from './fileEditComplete';
export {
  GENERATE_TEXT_TOOL_NAME,
  type GenerateTextArgs,
  type GenerateTextResult,
} from './generateText';
// Re-export validation
export {
  findToolNameByCallId,
  isBrandKitSetupResult,
  isDetectTextResult,
  isElicitMissingContextResult,
  isFileEditCompleteResult,
  isGenerateTextResult,
  parseToolContent,
  type ToolCallResultParams,
  type ToolResultValidationResult,
  type ValidatedToolCallResultParams,
  validateToolCallResult,
} from './validation';
